let sdkPromise;

export function loadWhatsAppSDK(appId, version = 'v26.0') {
  const initialize = () => {
    window.FB.init({ appId, autoLogAppEvents: false, xfbml: false, version });
    return window.FB;
  };
  if (window.FB) return Promise.resolve(initialize());
  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Facebook could not be loaded. Please try again.')), 15000);
      window.fbAsyncInit = () => { clearTimeout(timer); resolve(window.FB); };
      let script = document.getElementById('facebook-jssdk');
      if (!script) {
        script = document.createElement('script');
        script.id = 'facebook-jssdk'; script.src = 'https://connect.facebook.net/en_US/sdk.js';
        script.async = true; script.defer = true; script.crossOrigin = 'anonymous';
        document.body.appendChild(script);
      }
      script.onerror = () => { clearTimeout(timer); reject(new Error('Facebook could not be loaded. Please try again.')); };
    }).catch(error => { sdkPromise = null; throw error; });
  }
  return sdkPromise.then(initialize);
}

export function parseWhatsAppSession(event) {
  if (!['https://www.facebook.com', 'https://web.facebook.com'].includes(event.origin)) return null;
  try {
    const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
    return data?.type === 'WA_EMBEDDED_SIGNUP' ? data : null;
  } catch { return null; }
}

export async function waitForWhatsAppSession(ref) {
  // The authorization callback and session event can arrive in either order.
  for (let attempt = 0; attempt < 100; attempt += 1) {
    if (ref.current?.phone_number_id && ref.current?.waba_id) return ref.current;
    await new Promise(resolve => setTimeout(resolve, 100));
  }
  throw new Error('Meta did not return the selected WhatsApp number. Please connect again.');
}
